import { SummaryService } from '@/common/services/summary/summary.service';
import { replaceByObject } from '@/common/utils/strings/replace.utils';
import { SummaryResponse } from '@/core/domain/summary/models/summary-response.model';
import { SummaryRepository } from '@/core/domain/summary/repositories/summary.respository';
import { selectReservation } from '@/core/reservation/store/reservation.selector';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { first, Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SummaryImplRepository extends SummaryRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly store: Store,
        private summaryService: SummaryService,
    ) {
        super();
    }

    override getSummary(): Observable<SummaryResponse> {
        return this.store.select(selectReservation).pipe(
            first(),
            switchMap((reservation: unknown) => {
                return this.http.get<SummaryResponse>(
                    replaceByObject(
                        [
                            environment.alamoApi.BASE_HOST,
                            environment.alamoApi.ENDPOINTS.summary,
                        ].join('/'),
                        {
                            sessionId: _.get(reservation, 'uuid'),
                        },
                    ),
                    {
                        params: {
                            uniq: Date.now(),
                        },
                    },
                );
            }),
            switchMap((summaryResponse: SummaryResponse) => {
                this.summaryService.summary = summaryResponse.data;
                return of(summaryResponse);
            }),
        );
    }
}
